import { useIsVisible } from '@folklore/hooks';
import classNames from 'classnames';

import Coffee from './icons/Coffee';
import Flower from './icons/Flower';
import Surf from './icons/Surf';

// import HeaderBadge from './icons/HeaderBadge';

import styles from '../../styles/animations/tourisme-montreal/header.module.css';

interface HeaderProps {
    className?: string | null;
    layout?: string | null;
}

function Header({ className = null, layout = null }: HeaderProps) {
    const { ref, visible = false } = useIsVisible({ rootMargin: '-10%', persist: true });
    return (
        <div
            className={classNames(
                styles.container,
                {
                    [styles.visible]: visible,
                },
                className,
            )}
            data-layout={layout}
            ref={ref}
        >
            {/* <HeaderBadge className={styles.badge} /> */}
            <div className={styles.inner}>
                <h1 className={styles.title}>
                    <span className={styles.top}>6 endroits</span>
                    <span className={styles.middle}>
                        où se sentir en vacances
                        <br />
                        sans sortir de
                    </span>
                    <span className={styles.bottom}>Montréal</span>
                </h1>
                <p className={styles.subtitle}>
                    <span>
                        Redécouvrez votre ville grâce à<br />
                        nos suggestions d’activités.
                    </span>
                </p>
                <Coffee className={classNames([styles.icon, styles.coffee])} />
                <Flower className={classNames([styles.icon, styles.flower])} />
                <Surf className={classNames([styles.icon, styles.surf])} />
            </div>
            <p className={styles.credits}>Crédit photo : Villedepluie</p>
        </div>
    );
}

export default Header;
